'use client';

import { GoogleAnalytics as GoogleAnalyticsTag } from '@next/third-parties/google';
import Script from 'next/script';
import { useEffect, useState } from 'react';

const GA_ID = process.env.NEXT_PUBLIC_GA_ID;
// Manoel Network roll-up property: receives every hit from all sites
const ROLLUP_ID = process.env.NEXT_PUBLIC_GA_ROLLUP_ID;
const HOSTS = (process.env.NEXT_PUBLIC_GA_HOSTS ?? '')
  .split(',')
  .map((h) => h.trim())
  .filter(Boolean);

// Only loads GA on the production hostnames, so previews and localhost never send hits
export default function GoogleAnalytics() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(HOSTS.includes(window.location.hostname));
  }, []);

  if (!GA_ID || !enabled) return null;
  return (
    <>
      <GoogleAnalyticsTag gaId={GA_ID} />
      {/* Rendered after the tag so this config is queued after gtag('js') */}
      {ROLLUP_ID && (
        <Script id="ga-rollup" dangerouslySetInnerHTML={{ __html: `gtag('config', '${ROLLUP_ID}');` }} />
      )}
    </>
  );
}
